/**
 * ECharts展示主营业务收入和本年利润在 1 - 12 月的统计数据。
 */
export default {
    /**
     * 提示框组件配置，当鼠标悬停在图表元素上时显示相关信息。
     */
    tooltip: {
        // 触发类型为坐标轴，当鼠标悬停在坐标轴对应的数据上时显示提示框
        trigger: 'axis',
        /**
         * 坐标轴指示器配置，用于在坐标轴上显示对应的数据标记。
         */
        axisPointer: {
            // 指示器类型为阴影，在坐标轴上显示阴影效果
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
        },
        // 提示框内容的格式化字符串，显示横坐标名称、系列名称和对应数值
        formatter: '{b1}<br>{a0} {c0}K<br>{a1} {c1}K'
    },
    /**
     * 图例组件配置，用于展示不同系列数据的名称和颜色标识。
     */
    legend: {
        // 图例的数据项，对应图表中的不同系列
        data: ['本年利润', '主营业务收入']
    },
    /**
     * 图表网格区域配置，定义图表内容显示的范围。
     */
    grid: {
        // 网格左侧距离容器左边界的距离
        left: '3%',
        // 网格右侧距离容器右边界的距离
        right: '4%',
        // 网格底部距离容器底部边界的距离
        bottom: '3%',
        // 网格是否包含坐标轴标签，设置为 true 可避免标签被截断
        containLabel: true
    },
    /**
     * 工具箱组件配置，提供一些实用的工具功能。
     */
    toolbox: {
        // 是否显示工具箱
        show: true,
        /**
         * 工具箱中的工具特性配置。
         */
        feature: {
            // 标记功能，允许用户在图表上添加标记
            mark: {show: true},
            // 动态类型切换功能，支持切换为折线图和柱状图
            magicType: {show: true, type: ['line', 'bar']},
            // 还原功能，可将图表恢复到初始状态
            restore: {show: true},
            // 保存为图片功能，允许用户将图表保存为图片文件
            saveAsImage: {show: true}
        }
    },
    // 开启数据计算功能，已弃用，ECharts 5 及以上版本可移除该配置
    calculable: true,
    /**
     * 横坐标配置，支持多个横坐标，这里仅配置一个。
     */
    xAxis: [
        {
            // 坐标轴类型为类目型，用于展示离散的类目数据
            type: 'category',
            // 横坐标的类目数据，代表 1 - 12 月
            data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
        }
    ],
    /**
     * 纵坐标配置，支持多个纵坐标，这里仅配置一个。
     */
    yAxis: [
        {
            // 坐标轴类型为数值型，用于展示连续的数值数据
            type: 'value',
            /**
             * 坐标轴标签配置，用于格式化显示坐标轴上的数值。
             */
            axisLabel: {
                // 标签的格式化字符串，在数值后面添加 'K' 单位
                formatter: '{value} K'
            }
        }
    ],
    /**
     * 系列列表配置，每个系列代表一个图表类型和对应的数据。
     */
    series: [
        {
            // 系列名称，对应图例中的数据项
            name: '主营业务收入',
            // 图表类型为柱状图
            type: 'bar',
            // 系列的数据，目前 1 - 12 月的数据都为 0
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        },
        {
            // 系列名称，对应图例中的数据项
            name: '本年利润',
            // 图表类型为柱状图
            type: 'bar',
            // 系列的数据，目前 1 - 12 月的数据都为 0
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        }
    ]
};
